// Store event handlers to prevent duplicates
let globalClickHandler = null;
let globalChangeHandler = null;
let globalKeydownHandler = null;

function setupFilters() {
  // Function to update button text with count of selected options
  function updateButtonText(wrapper) {
    const button = wrapper.querySelector('.ms-btn button');
    const originalText = button.getAttribute('data-original-text') || button.textContent.split(' (')[0].trim();
    const checkboxes = wrapper.querySelectorAll('.ms-options input[type="checkbox"]:checked');

    // Store original text if not already stored
    if (!button.getAttribute('data-original-text')) {
      button.setAttribute('data-original-text', originalText);
    }

    // Update button text with count if there are checked items
    if (checkboxes.length > 0) {
      button.innerHTML = `${originalText} <span>&nbsp;(${checkboxes.length})</span><i class="sc sc-arrow-down"></i>`;
    } else {
      button.innerHTML = `${originalText}<i class="sc sc-arrow-down"></i>`;
    }
  }

  // Initialize all buttons
  document.querySelectorAll('.ms-wrapper').forEach(wrapper => {
    updateButtonText(wrapper);
  });

  // Remove existing global event listeners to prevent duplicates
  if (globalClickHandler) {
    document.removeEventListener('click', globalClickHandler);
  }
  if (globalChangeHandler) {
    document.removeEventListener('change', globalChangeHandler);
  }
  if (globalKeydownHandler) {
    document.removeEventListener('keydown', globalKeydownHandler);
  }

  // Create global click handler for all click events
  globalClickHandler = function(event) {
    // Handle multi-select button clicks
    if (event.target.matches('.ms-btn button') || event.target.closest('.ms-btn button')) {
      // Prevent event bubbling to document
      event.stopPropagation();

      const button = event.target.matches('.ms-btn button') ? event.target : event.target.closest('.ms-btn button');

      // Find the parent wrapper and the associated options element
      const wrapper = button.closest('.ms-wrapper');
      const options = wrapper.querySelector('.ms-options');

      // Check if this dropdown is already open
      const isCurrentlyOpen = !options.classList.contains('d-none');

      // First, remove all active states
      document.querySelectorAll('.ms-wrapper').forEach(wrap => {
        wrap.classList.remove('active');
      });

      // And close all dropdowns
      document.querySelectorAll('.ms-options').forEach(opt => {
        opt.classList.add('d-none');
      });

      // Reset all arrows
      document.querySelectorAll('.sc-arrow-down').forEach(arrow => {
        arrow.style.transform = 'rotate(0deg)';
      });

      // If current dropdown wasn't open, open it (toggle behavior)
      if (!isCurrentlyOpen) {
        options.classList.remove('d-none');
        wrapper.classList.add('active');

        // Rotate this button's arrow
        const arrow = button.querySelector('.sc-arrow-down');
        if (arrow) {
          arrow.style.transform = 'rotate(180deg)';
          arrow.style.transition = 'transform 0.2s';
        }
      }
      return;
    }

    // Handle filter list button clicks
    if (event.target.matches('.filterlistBtn') || event.target.closest('.filterlistBtn')) {
      event.preventDefault();

      const button = event.target.matches('.filterlistBtn') ? event.target : event.target.closest('.filterlistBtn');
      const targetSelector = button.getAttribute('href');
      if (!targetSelector) return; // Exit if no target specified

      const targetElement = document.querySelector(targetSelector);
      if (!targetElement) {
        console.warn(`Target element "${targetSelector}" not found`);
        return;
      }

      targetElement.classList.toggle('visually-hidden');

      // Configurable text
      const LABELS = {
        showMore: 'Meer',
        showLess: 'Minder',
        icons: {
          down: '<i class="bi bi-chevron-down me-1"></i>',
          up: '<i class="bi bi-chevron-up me-1"></i>'
        }
      };

      // Update button text and icon based on state
      const isHidden = targetElement.classList.contains('visually-hidden');
      button.innerHTML = isHidden ?
        `${LABELS.icons.down}${LABELS.showMore}` :
        `${LABELS.icons.up}${LABELS.showLess}`;
      return;
    }

    // Close dropdowns when clicking outside, but keep open when clicking inside options
    // If the click is on a checkbox or its label, don't do anything
    // This prevents dropdowns from closing when selecting checkboxes
    if (
      event.target.classList.contains('form-check-input') || 
      event.target.classList.contains('form-check-label') ||
      event.target.closest('.form-check') !== null
    ) {
      return;
    }

    // If click is not inside any multi-select wrapper, close all dropdowns
    if (!event.target.closest('.ms-wrapper')) {
      // Remove active class from all wrappers
      document.querySelectorAll('.ms-wrapper').forEach(wrapper => {
        wrapper.classList.remove('active');
      });

      // Hide all option lists
      document.querySelectorAll('.ms-options').forEach(options => {
        options.classList.add('d-none');
      });

      // Reset all arrows
      document.querySelectorAll('.sc-arrow-down').forEach(arrow => {
        arrow.style.transform = 'rotate(0deg)';
      });
    }
  };

  // Create global change handler for checkbox changes
  globalChangeHandler = function(event) {
    if (event.target.matches('.ms-options input[type="checkbox"]')) {
      const wrapper = event.target.closest('.ms-wrapper');
      updateButtonText(wrapper);
    }
  };

  // Create global keydown handler
  globalKeydownHandler = function(event) {
    if (event.key === 'Escape') {
      // Remove active class from all wrappers
      document.querySelectorAll('.ms-wrapper').forEach(wrapper => {
        wrapper.classList.remove('active');
      });

      // Close all dropdowns
      document.querySelectorAll('.ms-options').forEach(options => {
        options.classList.add('d-none');
      });

      // Reset all arrows
      document.querySelectorAll('.sc-arrow-down').forEach(arrow => {
        arrow.style.transform = 'rotate(0deg)';
      });
    }
  };

  // Add global event listeners
  document.addEventListener('click', globalClickHandler);
  document.addEventListener('change', globalChangeHandler);
  document.addEventListener('keydown', globalKeydownHandler);
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', setupFilters);

// Re-initialize on Turbo navigation
document.addEventListener('turbo:load', setupFilters);

// Re-initialize on Turbo Stream updates
document.addEventListener('turbo:render', setupFilters);

export { setupFilters }
